import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum ProductStatusIds {
  PENDING = 1,
  ACTIVE = 2,
  ON_HOLD = 3,
  RETIRED = 4,
}

export function getProductStatii(): ISelectItem[] {
  return [
    { id: ProductStatusIds.PENDING, label: 'Pending' },
    { id: ProductStatusIds.ACTIVE, label: 'Active' },
    { id: ProductStatusIds.ON_HOLD, label: 'On Hold' },
    { id: ProductStatusIds.RETIRED, label: 'Retired' },
  ]
}

export const getProductStatusByLabel = getItemByLabelFactory(getProductStatii)

export const getProductStatusById = getItemByIdFactory(getProductStatii)
